
export default {
  name: 'LoginModal',
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    isBP: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    open(value) {
      this.show = value
    }
  },
  methods: {
    handleOk() {
      //console.log(arguments, this.$refs.modalLogin)
    },
    closeModal() {
      this.$emit('closelogin')
    }
  }
}
